import { PluginName } from './plugin-name';
import type { PluginInvocation } from './types';

/**
 * Filters plugin invocations to exclude the search plugin.
 * The search plugin data is displayed separately in the search results panels.
 */
export const filterNonSearchPlugins = (
	pluginInvocations: PluginInvocation[] | undefined,
): PluginInvocation[] => {
	if (!Array.isArray(pluginInvocations)) {
		return [];
	}
	return pluginInvocations.filter((plugin) => plugin.plugin_name !== PluginName.SEARCH);
};
